import { Injectable } from "@angular/core";
import { DialogLike, DialogService } from "@obg/mat.ui.core";
import { map } from "rxjs/operators";

import { ENTITY_LEGAL_NOTICE_DIALOG_ID } from "./entity-legal-notice.const";
import { EntityLegalNoticeContainer } from "./entity-legal-notice.container";

const ENTITY_LEGAL_NOTICE_DIALOG: DialogLike<EntityLegalNoticeContainer> = {
	dialogId: ENTITY_LEGAL_NOTICE_DIALOG_ID,
	dialogComponentType: EntityLegalNoticeContainer,
	onClose$: (c) => c.close,
	onBusy$: (c) => c.busy.pipe(map((isBusy) => ({ isBusy }))),
};

@Injectable({
	providedIn: "root",
})
export class EntityLegalNoticeDialogService {
	constructor(private readonly dialogService: DialogService) {}

	open() {
		return () => {
			this.dialogService.openComponent(ENTITY_LEGAL_NOTICE_DIALOG, {
				disableClose: true,
				panelClass: "latest-privacy-policy-dialog",
				data: {
					hideClose: true,
					hideFooter: true,
				},
				autoFocus: false,
			});
		};
	}
}
